import { fetchApi } from '@/config/axiosSetting.ts';
import { SignatureRegistrationMutationDataType } from '@/modules/Dashboard/queries/sidebarSignature/signatureRegistrationMutation.type.ts';

export const signatureRegistrationMutationFn = (
  data: SignatureRegistrationMutationDataType,
) => fetchApi.post('sidebar/signature_registration/', data);
